import { FC } from 'react'

import { Pickup } from '@/widgets/ShopsMapNew'
import { ShopsMapPointType } from '@/widgets/ShopsMapNew/ui/ShopsMap/consts'

import { useRegion } from '@/entities/regions'

import { useGetShopsQuery } from '../../api/shops-api'

interface ShopsMapBlockProps {
	pointType?: ShopsMapPointType
}

export const ShopsMapBlock: FC<ShopsMapBlockProps> = ({ pointType }) => {
	const { data: shops, isLoading } = useGetShopsQuery(null)
	const { currentRegion } = useRegion()

	if (isLoading || !shops) return null

	const shopsByRegionAndPointType = shops?.filter(({ REGION, UF_IS_SERVICE, UF_IS_SHOP }) => {
		if (REGION === currentRegion.REGION_NAME) {
			if (pointType === ShopsMapPointType.Services) {
				return UF_IS_SERVICE === '1'
			} else {
				return UF_IS_SHOP === '1'
			}
		}

		return false
	})

	return <Pickup shops={shopsByRegionAndPointType} inProduct />
}
